<template>
	<div class="feedA">
		<el-row>
			<el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demoRuleForm">
				<el-col :span="24">
					<el-form-item label="标题" prop="title">
						<el-input v-model="ruleForm.title" placeholder="标题限30字以内" maxlength="30"></el-input>
					</el-form-item>
					<el-form-item label="正文" prop="content">
						<div class="textBox">
							<el-input v-model="ruleForm.content" resize="none" placeholder="请输入" type="textarea" maxlength="200" :rows="8"></el-input>
							<span>{{ ruleForm.content.length }}/200</span>
						</div>
					</el-form-item>
					<el-form-item label="图片" prop="coverUrls">
						<el-upload
							ref="upload"
							:action="upHttpUrl"
							:before-upload="befUpfn"
							:http-request="uploadImage"
							list-type="picture-card"
							:file-list="imgs"
							:on-success="handleAvatarSuccess"
							:on-remove="handleRemove"
							:on-preview="handlePictureCardPreview"
						>
							<div class="imgBox">
								<img src="@/assets/img/sc.svg" alt="" />
								<p>点击上传</p>
							</div>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="lookImg" alt="" />
						</el-dialog>
					</el-form-item>
					<el-form-item label="电话" prop="phone">
						<el-input v-model="ruleForm.phone" placeholder="预留您的联系方式以便沟通" maxlength="11"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<div class="regFot">
						<div class="regBtn" @click="fhFn">取消</div>
						<div class="regBtn active" @click="subFn">提交</div>
					</div>
				</el-col>
			</el-form>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'feedA',
	data() {
		return {
			ruleForm: {
				title: '',
				content: '',
				coverUrls: [],
				phone: ''
			},
			upHttpUrl: '',
			upHttpKey: '',
			wjName: '',
			dialogVisible: false,
			lookImg: '',
			imgs: []
		};
	},
	methods: {
		uploadImage(file) {
			// 这里的`file`参数是要上传的文件对象
			// 在这里根据需要添加一些逻辑，如显示进度条
			const xhr = new XMLHttpRequest();
			//element-ui默认使用post提交，但是我们生成的url需要使用 put 提交
			//需要指定 put 直传，以及this.upHttpUrl（后端返回的url）
			xhr.open('PUT', this.upHttpUrl, true);
			//设置上传文件的类型
			xhr.setRequestHeader('Content-Type', file.file.type); // 或者 file.type
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						//进入到这里就表明上传成功了
						//我这里对后端返回的url进行截取方便存入数据库，因为前端还需要展示图片
						let indexOf = this.upHttpUrl.indexOf('?');
						console.log(this.upHttpUrl.slice(0, indexOf), xhr.response, 55555);
						this.$http
							.post('api/app/common/upFileAttachment', {
								key: this.upHttpKey,
								originalFileName: this.wjName
							})
							.then((red) => {
								this.ruleForm.coverUrls.push(red.data.attDir);
								this.imgs.push({
									name: this.wjName,
									url: this.$imgUrl + red.data.attDir
								});
								console.log(red);
							});
					} else {
					}
				}
			};
			//发送
			xhr.send(file.file); //或者 file
		},
		async befUpfn(e) {
			console.log(e, 7777);
			this.wjName = e.name;
			await this.$http
				.get('api/app/common/getToken', {
					params: {
						fileName: e.name
					}
				})
				.then((res) => {
					console.log(9999);
					this.upHttpUrl = res.data.host;
					this.upHttpKey = res.data.key;
				});
		},
		handleAvatarSuccess(res, file) {
			if (res.code == 200) {
				this.ruleForm.coverUrls.push(res.data.url);
				this.imgs.push({
					name: file.name,
					url: URL.createObjectURL(file.raw)
				});
			}
		},
		handlePictureCardPreview(file) {
			this.lookImg = file.url;
			this.dialogVisible = true;
		},
		handleRemove(file) {
			console.log(file, 777);
			console.log(this.imgs, 888);
			console.log(this.ruleForm.coverUrls, 999);
			this.imgs = this.imgs.filter((item) => {
				return !file.url.includes(item.url);
			});
			this.ruleForm.coverUrls = this.ruleForm.coverUrls.filter((item) => {
				return !file.url.includes(item.url);
			});
		},
		subFn() {
			this.$nextTick(() => {
				console.log(this.ruleForm, 9999);
				let { coverUrls, ...ruData } = this.ruleForm;
				this.$http
					.post('api/app/yydFeedback', {
						...ruData,
						coverUrls: coverUrls.join(',')
					})
					.then((res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '提交成功'
							});
							this.ruleForm = {
								title: '',
								content: '',
								coverUrls: [],
								phone: ''
							};
							this.imgs = [];
						}
					});
			});
		},
		fhFn() {
			this.$router.back();
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.feedA {
	padding: 35px 412px 40px 21px;
	.textBox {
		padding: 4px 0;
		position: relative;
		span {
			color: #ababab;
			position: absolute;
			bottom: 0;
			right: 10px;
			z-index: 99;
		}
	}
	.imgBox {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		img {
			width: 20px;
			height: 18px;
			margin-bottom: 8px;
		}
		p {
			color: #ababab;
			font-size: 12px;
			line-height: 1;
		}
	}
}
.regFot {
	display: flex;
	justify-content: center;
	margin-top: 27px;

	.regBtn {
		width: 88px;
		height: 40px;
		margin-right: 25px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;

		&:last-of-type {
			margin-right: 0;
		}
	}

	.active {
		background: #1d7b3a;
		color: #ffffff;
		border: 1px solid #1d7b3a;
	}
}
</style>
